import styled from 'styled-components';
import { responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

interface ArticleCardWrapperProps {
	$borderColor?: string;
}

export const ArticleCardWrapper = styled.section<ArticleCardWrapperProps>`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 32px 24px;
    border-radius: 5px;
    border: 4px solid ${({$borderColor}) => $borderColor};
    background: #fff;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 24px;
    gap: 40px;
    @media screen and (${maxTablet}) {
        grid-template-columns: unset;
        padding: 24px 16px;
        gap: 16px;
    }
`;

export const ArticleCardContainer = styled.div``;

export const ArticleTwoColumn = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (${maxTablet}) {
        justify-content: space-evenly;
        margin-bottom: 0;
    }
    margin-bottom: 24px;

    img {
        max-height: 120px;
        max-width: 120px;
    }
`;

export const ArticleCardHeading = styled.h4`
	color: #333;
	text-align: center;
	font-size: 24px;
	font-weight: 700;
	line-height: 130%;
`;

export const ArticleCardText = styled.div`
    color: #636363;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    margin: 16px 0;
    @media screen and (${maxTablet}) {
        margin: 8px 0;
    }
`;
